var lydz = {

    richangyanghu: {
        name: '日常保洁记录表',
        key: 'dailyRecord'
    },
    richangxuncha: {
        name: '日常巡查记录表',
        key: 'nightRecord',

    },

    deptName: {
        name: '签字确认',
        key: 'qianzi'
    },
    yuyanshou: {
        name: '验收单填写',
        key: 'yanshou'
    },
    yanshouqianzi: {
        name: '验收签字',
        key: 'qianzi',
    },
    qianzi: {
        name: '负责人签字',
        key: 'qianzi',
    },
    empty: {

    },
    banzuzhang: {
        autoSelectUser: true
    },
    biaodanxiugai: {
        name: '表单修改',
        key: 'biaodanxiugai',
    },
};

export default lydz;


// WEBPACK FOOTER //
// ./src/components/yhgl/forms/rule.js